import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=18c0cc76&"
import script from "./DetailSection.vue?vue&type=script&lang=js&"
export * from "./DetailSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=18c0cc76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports